<app-dialog-overlay>
  <div class="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
    @if (data.imageUrl) {
      <img
        class="w-full"
        [src]="data.imageUrl"
        alt="Logo"
        [style]="data.imageStyle"
      />
    }

    <h3 class="-mt-1 text-lg font-semibold text-gray-900" id="modal-title">
      {{ data.title | translate }}
    </h3>
    <p class="text-sm mt-2.5">{{ data.message | translate }}</p>

    @if (!!data.buttonsConfig) {
      <div class="grid gap-2.5 mt-5">
        @for (buttonConfig of data.buttonsConfig; track buttonConfig) {
          <app-button
            (click)="closeDialog(buttonConfig.action, buttonConfig?.callback)"
            [color]="buttonConfig.color"
            [class]="buttonConfig.class"
          >
            {{ buttonConfig.translation | translate }}
          </app-button>
        }
      </div>
    }
  </div>
</app-dialog-overlay>
